import { str, bool, date, FieldMap } from '../acordFieldEngine';


export const PROPERTY_MAP: FieldMap = {
  insurerLtr:         str('Property_InsurerLetterCode_A'),
  checked:            bool('Policy_PolicyType_PropertyIndicator_A'),
  policyNumber:       str('Policy_PolicyNumberIdentifier_A'),
  effDate:            date('Policy_EffectiveDate_A'),
  expDate:            date('Policy_ExpirationDate_A'),
  basic:              bool('Policy_PolicyType_BasicIndicator_A'),
  broad:              bool('Policy_PolicyType_BroadIndicator_A'),
  special:            bool('Policy_PolicyType_SpecialIndicator_A'),
  earthquake:         bool('CommercialPropertyCoverage_EarthquakeOption_IncludedIndicator_A'),
  wind:               bool('Policy_PolicyType_WindIndicator_A'),
  flood:              bool('CommercialPropertyCoverage_Flood_YesIndicator_A'),
  other1:             bool('Policy_PolicyType_OtherIndicator_A'),
  other1Text:         str('Policy_PolicyType_OtherDescription_A'),
  other1Deduct:       str('CommercialProperty_Premises_DeductibleAmount_F'),
  other2:             bool('Policy_PolicyType_OtherIndicator_B'),
  other2Text:         str('Policy_PolicyType_OtherDescription_B'),
  other2Deduct:       str('CommercialProperty_Premises_DeductibleAmount_G'),
  deductBuilding:     str('CommercialProperty_Premises_DeductibleAmount_A'),
  deductContents:     str('CommercialProperty_Premises_DeductibleAmount_B'),
  earthquakeDeduct:   str('CommercialProperty_Premises_DeductibleAmount_C'),
  windDeduct:         str('CommercialProperty_Premises_DeductibleAmount_D'),
  floodDeduct:        str('CommercialProperty_Premises_DeductibleAmount_E'),
  covBuilding:        bool('Property_Building_CoverageIndicator_A'),
  limBuilding:        str('Property_Building_LimitAmount_A'),
  covPersonalProp:    bool('Property_PersonalProperty_CoverageIndicator_A'),
  limPersonalProp:    str('Property_PersonalProperty_LimitAmount_A'),
  covBusinessIncome:  bool('CommercialPropertyCoverage_BusinessIncomeOption_IncludedIndicator_A'),
  limBusinessIncome:  str('CommercialPropertyCoverage_BusinessIncome_LimitAmount_A'),
  covExtraExpense:    bool('CommercialPropertyCoverage_ExtraExpenseOption_IncludedIndicator_A'),
  limExtraExpense:    str('CommercialPropertyCoverage_ExtraExpense_LimitAmount_A'),
  covRentalValue:     bool('CommercialPropertyCoverage_RentalValueOption_IncludedIndicator_A'),
  limRentalValue:     str('CommercialPropertyCoverage_RentalValue_LimitAmount_A'),
  otherCov1:          bool('PropertyCoverage_OtherOption_IncludedIndicator_A'),
  otherCov1Desc:      str('PropertyCoverage_Other_CoverageDescription_A'),
  otherCov1Lim:       str('PropertyCoverage_Other_LimitAmount_A'),
  otherCov2:          bool('PropertyCoverage_OtherOption_IncludedIndicator_B'),
  otherCov2Desc:      str('PropertyCoverage_Other_CoverageDescription_B'),
  otherCov2Lim:       str('PropertyCoverage_Other_LimitAmount_B'),
  covBlanketBuilding: bool('CommercialProperty_Blanket_YesIndicator_A'),
  limBlanketBuilding: str('CommercialProperty_Blanket_LimitAmount_A'),
  covBlanketPersProp: bool('CommercialProperty_Blanket_YesIndicator_B'),
  limBlanketPersProp: str('CommercialProperty_Blanket_LimitAmount_B'),
  covBlanketBldgPP:   bool('CommercialProperty_Blanket_YesIndicator_C'),
  limBlanketBldgPP:   str('CommercialProperty_Blanket_LimitAmount_C'),
};


export const INLAND_MAP: FieldMap = {
  insurerLtr:        str('CommercialInlandMarineLineOfBusiness_InsurerLetterCode_A'),
  checked:           bool('Policy_PolicyType_InlandMarineIndicator_A'),
  namedPerils:       bool('CommercialInlandMarineCoverage_Option_NamedPerilsIndicator_A'),
  otherPerils:       bool('Policy_PolicyType_OtherIndicator_D'),
  otherPerilsText:   str('Policy_PolicyType_OtherDescription_D'),
  typeOfPolicy:      str('Policy_PolicyType_OtherDescription_C'),
  policyNumber:      str('Policy_PolicyNumberIdentifier_B'),
  effDate:           date('Policy_EffectiveDate_B'),
  expDate:           date('Policy_ExpirationDate_B'),
  cov1:              bool('CommercialInlandMarineCoverage_Other_CoverageIndicator_A'),
  cov1Desc:          str('CommercialInlandMarineCoverage_Other_CoverageDescription_A'),
  cov1Lim:           str('CommercialInlandMarineCoverage_Other_LimitAmount_A'),
  cov2:              bool('CommercialInlandMarineCoverage_Other_CoverageIndicator_B'),
  cov2Desc:          str('CommercialInlandMarineCoverage_Other_CoverageDescription_B'),
  cov2Lim:           str('CommercialInlandMarineCoverage_Other_LimitAmount_B'),
  cov3:              bool('CommercialInlandMarineCoverage_Other_CoverageIndicator_C'),
  cov3Desc:          str('CommercialInlandMarineCoverage_Other_CoverageDescription_C'),
  cov3Lim:           str('CommercialInlandMarineCoverage_Other_LimitAmount_C'),
  cov4:              bool('CommercialInlandMarineCoverage_Other_CoverageIndicator_D'),
  cov4Desc:          str('CommercialInlandMarineCoverage_Other_CoverageDescription_D'),
  cov4Lim:           str('CommercialInlandMarineCoverage_Other_LimitAmount_D'),
};


export const CRIME_MAP: FieldMap = {
  insurerLtr:    str('CrimeLineOfBusiness_InsurerLetterCode_A'),
  checked:       bool('CrimeLineOfBusiness_CoverageIndicator_A'),
  typeOfPolicy:  str('Policy_PolicyType_OtherDescription_E'),
  policyNumber:  str('Policy_PolicyNumberIdentifier_C'),
  effDate:       date('Policy_EffectiveDate_C'),
  expDate:       date('Policy_ExpirationDate_C'),
  cov1:          bool('CrimeCoverage_OtherCoverage_CoverageIndicator_A'),
  cov1Desc:      str('CrimeCoverage_OtherCoverage_CoverageDescription_A'),
  cov1Lim:       str('CrimeCoverage_OtherCoverage_LimitAmount_A'),
  cov2:          bool('CrimeCoverage_OtherCoverage_CoverageIndicator_B'),
  cov2Desc:      str('CrimeCoverage_OtherCoverage_CoverageDescription_B'),
  cov2Lim:       str('CrimeCoverage_OtherCoverage_LimitAmount_B'),
  cov3:          bool('CrimeCoverage_OtherCoverage_CoverageIndicator_C'),
  cov3Desc:      str('CrimeCoverage_OtherCoverage_CoverageDescription_C'),
  cov3Lim:       str('CrimeCoverage_OtherCoverage_LimitAmount_C'),
};


export const BOILER_MAP: FieldMap = {
  insurerLtr:    str('BoilerAndMachineryLineOfBusiness_InsurerLetterCode_A'),
  checked:       bool('BoilerAndMachineryLineOfBusiness_CoverageIndicator_A'),
  policyNumber:  str('Policy_PolicyNumberIdentifier_D'),
  effDate:       date('Policy_EffectiveDate_D'),
  expDate:       date('Policy_ExpirationDate_D'),
  cov1:          bool('BoilerAndMachineryCoverage_OtherCoverage_CoverageIndicator_A'),
  cov1Desc:      str('BoilerAndMachineryCoverage_OtherCoverage_CoverageDescription_A'),
  cov1Lim:       str('BoilerAndMachineryCoverage_OtherCoverage_LimitAmount_A'),
  cov2:          bool('BoilerAndMachineryCoverage_OtherCoverage_CoverageIndicator_B'),
  cov2Desc:      str('BoilerAndMachineryCoverage_OtherCoverage_CoverageDescription_B'),
  cov2Lim:       str('BoilerAndMachineryCoverage_OtherCoverage_LimitAmount_B'),
};


export const OTHER24_MAP: FieldMap = {
  insurerLtr:    str('OtherPolicy_InsurerLetterCode_A'),
  type:          str('OtherPolicy_OtherPolicyDescription_A'),
  policyNumber:  str('OtherPolicy_PolicyNumberIdentifier_A'),
  effDate:       date('OtherPolicy_PolicyEffectiveDate_A'),
  expDate:       date('OtherPolicy_PolicyExpirationDate_A'),
  cov1:          bool('OtherPolicy_CoverageIndicator_A'),
  cov1Desc:      str('OtherPolicy_CoverageDescription_A'),
  cov1Lim:       str('OtherPolicy_CoverageLimitAmount_A'),
  cov2:          bool('OtherPolicy_CoverageIndicator_B'),
  cov2Desc:      str('OtherPolicy_CoverageDescription_B'),
  cov2Lim:       str('OtherPolicy_CoverageLimitAmount_B'),
};
